import type { AccessibilityProps } from 'react-native'
import * as Comp from './modal-description.styles'

interface TModalDescriptionProps extends AccessibilityProps {
  children: string
  testID?: string
}

export function ModalDescription({ children, testID }: TModalDescriptionProps) {
  const componentProperties = {
    testID,
  }

  return (
    <Comp.Description numberOfLines={5} {...componentProperties}>
      {children}
    </Comp.Description>
  )
}
